import React from 'react'

const BlogDetailLeaveMessageForm = () => {
  return (
    <section className='p-5 rounded-3xl bg-white shadow-sm'>
      <article className='flex flex-col gap-y-3'>
        <h1 data-aos="fade-up" data-aos-duration="700" className='font-semibold text-4xl familjen-font'>Leave a Reply</h1>
        <p data-aos="fade-up" data-aos-duration="700">Your email address will not be published. Required fields are marked *</p>
      </article>
      <form method="post" className='sm:grid flex flex-col gap-y-3 sm:grid-cols-2 grid-cols-1 sm:gap-5 gap-2 mt-10'>
        <div className='flex flex-col gap-y-1 sm:col-span-2 w-full'>
          <label className='capitalize text-sm' htmlFor="comment">comment</label>
          <textarea className='border border-gray-300 p-3 focus:outline-[#0BB6D9] transition-all duration-500' required rows={5} name="comment" id="comment"></textarea>
        </div>
        <div className='flex flex-col gap-y-1'>
          <label className='capitalize text-sm' htmlFor="name">name</label>
          <input className='border border-gray-300 p-3 focus:outline-[#0BB6D9] transition-all duration-500' required type="text" name="name" id="name" />
        </div>
        <div className='flex flex-col gap-y-1'>
          <label className='capitalize text-sm' htmlFor="email">email</label>
          <input className='border border-gray-300 p-3 focus:outline-[#0BB6D9] transition-all duration-500' required type="email" name="email" id="email" />
        </div>
        <div className='flex flex-col gap-y-1 sm:col-span-2'>
          <label className='capitalize text-sm' htmlFor="website">website</label>
          <input className='border border-gray-300 p-3 focus:outline-[#0BB6D9] transition-all duration-500' required type="url" name="website" id="website" />
        </div>
        <div className='col-span-2 flex gap-2 text-sm'>
          <input type="checkbox" name="save" id="save" />
          <label htmlFor="save"> Save my name, email, and website in this browser for the next time I comment.</label>
        </div>
        <button type="submit" className='p-3 rounded-sm hover:bg-black transition-all duration-500 bg-[#0BB6D9] text-white font-semibold capitalize w-fit'>post comment</button>
      </form>
    </section>
  )
}

export default BlogDetailLeaveMessageForm